import React, { useEffect, useState, useRef, useContext, useMemo, useLayoutEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { M_StateActions } from '../M_Store/stateSlice'
import './M_Table.css'
import { useTranslation } from "react-i18next"
import { Accordion, AccordionSummary, AccordionDetails, Badge, InputAdornment, InputBase, Menu, MenuItem, useMediaQuery } from '@mui/material'
import { Search, Close, PushPinOutlined, AddCircleOutlineOutlined, ArrowDownward, CloseRounded, BorderRight } from '@mui/icons-material'
import { DataTable } from 'primereact/datatable/datatable.cjs.js'
import { Column } from 'primereact/column/column.cjs.js'
import { ColumnGroup } from 'primereact/columngroup/columngroup.cjs.js'
import { Row } from 'primereact/row/row.cjs.js'
import { ContextMenu } from 'primereact/contextmenu/contextmenu.cjs.js'
import { Paginator } from 'primereact/paginator/paginator.cjs.js'
import * as XLSX from "xlsx"
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import { CrudTable, AdvanceFilter, BufferService, filtersSortService, LoadingBar, LoadingContext, MSwitchButton, M_Button, M_CheckBox, M_MessageBoard, M_InputTextField } from '../../M_Components'
import * as Excel from "exceljs"
import { saveAs } from 'file-saver'
import { Clear, Done } from '@mui/icons-material'
import { mergeTableColorOptions } from './statusColorOptions'

export function M_Table({ entityName, useSessionStorage, crud, onPassLine, onPassContext,
    tableHeight, manualId, rolePermissions, lineContext, extraButtons, removeContextItems,
    onHideLabels, toUseFilter, toUseFilterName, selectSingle, refresh, setRefresh,
    isParentTable, isChildTable, setParentLine, parentLine, field, roleName, FILTER,
    replaceFunctions, hasConfirmation, color, secondColor, rowGroup, groupField, headerTemplate,
    footerTemplate, colorOptions, noSelect, maxRows, includeImportExcel, includeTemplateExcel,
    value, valueField, valueIdField, removeHeaders, filtersOnTable, infoElement, orderFields, hideDefaultColor,
    inputFilter, stopSaveRows, inputText, getOptionsParams, query, rowClassName,
    queryRequestBody, queryPostPath }) {

    const dispatch = useDispatch()
    const M_State = useSelector((state) => state.StateKeyValue)
    const tableColorOptions = useMemo(() => mergeTableColorOptions(colorOptions), [colorOptions])

    const ctx = useContext(LoadingContext)
    color = color ? color : ctx.primaryColor ? ctx.primaryColor : "var(--color-black)"
    secondColor = secondColor ? secondColor : ctx.secondaryColor ? ctx.secondaryColor : "var(--color-black)"

    removeHeaders = removeHeaders ? removeHeaders : []

    const nameForRole = roleName ? roleName : entityName
    const isSelectSingle = selectSingle !== undefined ? selectSingle : false
    const passFilterName = toUseFilterName ? toUseFilterName : 'Default'
    const passFilter = toUseFilter ? toUseFilter : new Map()
    const removeItem = removeContextItems ? removeContextItems : []
    const newButtons = extraButtons ? extraButtons : []
    const roles = rolePermissions ? rolePermissions : []
    const contextMenu = lineContext ? lineContext : []
    const entity = entityName
    const isPage = useSessionStorage !== undefined ? useSessionStorage : true
    const isCrud = crud !== undefined ? crud : true
    // const adjustingTableMedia1 = useMediaQuery('(min-width:1542px)')
    const adjustingTableMedia2 = useMediaQuery('(min-width:1200px)')
    const adjustingTableMedia3 = useMediaQuery('(min-width:500px)')

    const breakAuditWidth = useMediaQuery('(min-width:800px)')
    const breakAuditWidth2 = useMediaQuery('(min-width:500px)')

    const computeTableHeight = () => {
        if (typeof window === 'undefined') return tableHeight || 600
        const headerSize = document.querySelector('.p-datatable-header')?.offsetHeight || 60
        const paginatorSize = document.querySelector('.paginator')?.offsetHeight || 60
        const tabSize = document.querySelector('.divTabs')?.offsetHeight || 50
        const tempSize = window.innerHeight - (headerSize + paginatorSize + tabSize + 3)
        return Math.max(280, tempSize)
    }

    const [tableHeightPx, setTableHeightPx] = useState(() => computeTableHeight())

    useLayoutEffect(() => {
        const update = () => setTableHeightPx(computeTableHeight())
        update()
        window.addEventListener('resize', update)
        return () => window.removeEventListener('resize', update)
    }, [])

    const height = tableHeight ? tableHeight : tableHeightPx
    const { t } = useTranslation()

    const maxWidth = useMediaQuery('(min-width:1050px)')

    const [id, setId] = useState(manualId === undefined ? M_State.filter(obj => obj.key === 'selectedTab')[0]?.value : manualId)

    const [rows, setRows] = useState([])
    const [columns, setColumns] = useState([])

    const [allColumns, setAllColumns] = useState([])

    const [companies, setCompanies] = useState([])

    //* pagination stuff ( not working right )
    const [firstRows, setFirstRows] = useState(0)

    const [page, setPage] = useState(1)
    // const [pageSize, setPageSize] = useState(20)
    const [pageSize, setPageSize] = useState(maxRows ? maxRows : 20)
    const [totalRows, setTotalRows] = useState(50)

    //* columns to show up in table
    const [selectedColumns, setSelectedColumns] = useState([])

    //* selected lines
    const [selectedRows, setSelectedRows] = useState(Array.isArray(value) && value && [...value] || value && value || [])

    //* save line for context menu
    const [selectContext, setSelectContext] = useState(null)

    //* filters and sort
    const [globalFilterValue, setGlobalFilterValue] = useState('')
    const [orderInfo, setOrderInfo] = useState({ columnName: '', orderbool: false })
    const [metaPair, setMetaPair] = useState([])     //*{name:'',type:'',operation:'',value:''}
    const [metaType, setMetaType] = useState([])    //*{metaName:'',metaType:''}
    const [advFilterString, setAdvFilterString] = useState('')
    const [showFilters, setShowFilters] = useState(false)
    const [anchorAF, setAnchorAF] = useState(null)

    const [expandedRows, setExpandedRows] = useState([])

    //* CRUD STUFF ( not in session storage ( maybe its gonna be changed))

    //* Open/close delete modal
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false)
    //* Map with values from create modal
    const [valueAdd, setValueAdd] = useState(new Map())
    //* object to be edited ( dont know why its an array )
    const [rowEdit, setRowEdit] = useState([])
    //* individual edits saved in a Map
    const [editMap, setEditMap] = useState(new Map())
    //* to change the edit modal to a create with filled values
    const [isCopy, setIsCopy] = useState(false)
    //* sent to crudtable with the line to edit/copy information
    const [row, setRow] = useState(null)
    //* used to defined the type of operation of crud ( create/edit/copy )
    const [operation, setOperation] = useState('')

    //* show/ hide columns
    const [filteredColumnModal, setFilteredColumnModal] = useState([])
    const [valueFilteredColumnModal, setValueFilteredColumnModal] = useState('')
    const [columnContextMenuString, setColumnContextmenuString] = useState({})
    const [anchorEls, setAnchorEls] = useState(null) //* not being sent to session ( its a modal)

    //* Views
    const [anchorV, setAnchorV] = useState(null)
    const [views, setViews] = useState(passFilter)
    const [selectedView, setSelectedView] = useState(passFilterName)

    //* open modal for prints
    const [anchorEl, setAnchorEl] = useState(null) //* not being sent to session ( its a modal)
    const [isFirstLoop, setIsFirstLoop] = useState(true)
    const [isTable, setIsTable] = useState(true)
    const [isLoaded, setIsLoaded] = useState(true)
    const [loading, setLoading] = useState(false)
    const [permissions, setPermissions] = useState([])

    const bufferService = useMemo(() => new BufferService(entity), [entity])
    const bufferServiceOptions = useMemo(() => new BufferService(getOptionsParams ? getOptionsParams : entity), [getOptionsParams, entity])
    const bufferImportService = useMemo(() => new BufferService(`${entity}/Import`), [entity])
    const bufferExportService = useMemo(() => new BufferService(`${entity}/ExportData`), [entity])
    const filterService = useMemo(() => new filtersSortService(), [])
    const dt = useRef(null)
    const cm = useRef(null)
    const ccm = useRef(null)
    const globalSearchTimeoutRef = useRef(null)
    const openMenuPrint = Boolean(anchorEl)
    const openMenuHideColumns = Boolean(anchorEls)
    const openMenuViews = Boolean(anchorV)

    const auditService = useMemo(() => new BufferService('audit'), [])
    const [openAudit, setOpenAudit] = useState(false)
    const [auditData, setAuditData] = useState([])

    const fetchRows = (url) => {
        const requestBody = typeof queryRequestBody === 'function'
            ? queryRequestBody()
            : queryRequestBody

        if (requestBody !== undefined && requestBody !== null) {
            return bufferService.postPath(`${queryPostPath || ''}${url}`, requestBody)
        }

        return bufferService.filter(url)
    }

    //*campos do menu de contexto

    const [dataContextMenu, setDataContextMenu] = useState(null)

    const columnContextMenu = [
        {
            label: t("OrderAsc"), icon: (<i className='pi pi-sort-amount-down-alt' style={{ color: color }}></i>), command: () => {
                setOrderInfo({ columnName: columnContextMenuString, orderbool: false })
                getWithFilters({ columnName: columnContextMenuString, orderbool: false })
            }
        },
        {
            label: t("OrderDesc"), icon: (<i className='pi pi-sort-amount-up-alt' style={{ color: color }}></i>), command: () => {
                setOrderInfo({ columnName: columnContextMenuString, orderbool: true })
                getWithFilters({ columnName: columnContextMenuString, orderbool: true })
            }
        },
        { label: t("Remove"), icon: (<i className="pi pi-times" style={{ color: color }}></i>), command: () => onColumnToggle(getColumnObj(columnContextMenuString)) },
    ]

    const sessionKeys = ['rows', 'columns', 'selectedColumns', 'globalFilterValue', 'metaPair', 'advFilterString', 'filteredColumnModal', 'valueFilteredColumnModal', 'selectedRows', 'metaType', 'showFilters', 'orderInfo', 'operation', 'isTable', 'rowEdit', 'valueAdd', 'isCopy', 'editMap', 'row', 'totalRows', 'views', 'selectedView', 'pageSize', 'page', 'firstRows', 'companies', 'expandedRows']

    //*chamada a API dos dados da tabela

    useEffect(() => {
        // debugger
        if (isFirstLoop) {
            setIsLoaded(true)
            getSessionStorageData(id)
            getPermissions()
            setIsFirstLoop(false)

        }
        // eslint-disable-next-line
    }, [])

    const getSeverity = (data, column) => {
        const tempArray = tableColorOptions.get(column) || []
        const normalizedData = String(data ?? '').toLowerCase()
        const tempColor = tempArray.filter(obj => String(obj.value ?? '').toLowerCase() === normalizedData)
        if (tempColor.length > 0) {
            return tempColor[0].severity
        } else {
            return '#000000'
        }
    }

    const sessionStorageMachine = (id, key, value) => {
        let tempObj = {}
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (Array.from(eval(value))) }
        } else {
            // eslint-disable-next-line
            if (!(stopSaveRows && key === 'rows')) {
                tempObj = { key: `${key}`, value: (eval(value)) }
            } else { return null }
        }
        return tempObj
    }


    const selectedIncomingValue = (data) => {
        if (value) {
            if (Array.isArray(value)) {
                const tempArray = []
                const newTempArray = []

                //* GET THE REAL OBJECTS FROM THE VALUE ARRAY 
                value.forEach(objValue => {
                    if (valueIdField) {
                        const temp = data.Items.filter(obj => obj[valueIdField] === objValue[valueIdField])
                        if (temp.length) {
                            tempArray.push(temp[0])
                        }
                    } else {
                        const temp = data.Items.filter(obj => obj?.Id === objValue?.Id)
                        if (temp.length) {
                            tempArray.push(temp[0])
                        }
                    }
                })

                if (selectedRows.length) {
                    let newTemp = []

                    selectedRows.forEach(obj => {
                        if (!tempArray.find(tempObj => tempObj.Id === obj.Id)) {
                            newTemp.push(obj)
                        }
                    })
                    newTemp.push(...tempArray)
                    newTempArray.push(...newTemp)

                } else {
                    newTempArray.push(...tempArray)
                }
                setSelectedRows([...newTempArray])
            } else {
                //* GET THE OBJECT VALUE 
                if (valueIdField && value[valueIdField]) {
                    const tempArray = data.Items.filter(obj => obj[valueIdField] === value[valueIdField])
                    setSelectedRows(tempArray)
                } else {
                    if (value?.Id) {
                        const tempArray = data.Items.filter(obj => obj?.Id === value?.Id)
                        setSelectedRows(tempArray)
                    }
                }
            }
        }
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        if (isPage) {
            const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value

            if (M_StateData) {
                if (!stopSaveRows) {
                    const tempRs = M_StateData?.filter(obj => obj?.key === `rows`)[0]?.value
                    if (tempRs !== "undefined" && tempRs && (tempRs)?.length !== 0) {
                        setRows((tempRs))
                    }
                }
                const tempC = M_StateData?.filter(obj => obj?.key === 'columns')[0]?.value
                const tempSC = M_StateData?.filter(obj => obj?.key === 'selectedColumns')[0]?.value
                const tempGFV = M_StateData?.filter(obj => obj?.key === 'globalFilterValue')[0]?.value
                const tempMP = M_StateData?.filter(obj => obj?.key === 'metaPair')[0]?.value
                const tempAFS = M_StateData?.filter(obj => obj?.key === 'advFilterString')[0]?.value
                const tempFCM = M_StateData?.filter(obj => obj?.key === 'filteredColumnModal')[0]?.value
                const tempVFCM = M_StateData?.filter(obj => obj?.key === 'valueFilteredColumnModal')[0]?.value
                const tempMT = M_StateData?.filter(obj => obj?.key === 'metaType')[0]?.value
                const tempSF = M_StateData?.filter(obj => obj?.key === 'showFilters')[0]?.value
                const tempOI = M_StateData?.filter(obj => obj?.key === 'orderInfo')[0]?.value
                const tempO = M_StateData?.filter(obj => obj?.key === 'operation')[0]?.value
                const tempIT = M_StateData?.filter(obj => obj?.key === 'isTable')[0]?.value
                const tempRE = M_StateData?.filter(obj => obj?.key === 'rowEdit')[0]?.value
                const tempVA = M_StateData?.filter(obj => obj?.key === 'valueAdd')[0]?.value
                const tempIC = M_StateData?.filter(obj => obj?.key === 'isCopy')[0]?.value
                const tempEM = M_StateData?.filter(obj => obj?.key === 'editMap')[0]?.value
                const tempR = M_StateData?.filter(obj => obj?.key === 'row')[0]?.value
                const tempTR = M_StateData?.filter(obj => obj?.key === 'totalRows')[0]?.value
                const tempV = M_StateData?.filter(obj => obj?.key === 'views')[0]?.value
                const tempSV = M_StateData?.filter(obj => obj?.key === 'selectedView')[0]?.value
                const tempPS = M_StateData?.filter(obj => obj?.key === 'pageSize')[0]?.value
                const tempP = M_StateData?.filter(obj => obj?.key === 'page')[0]?.value
                const tempFR = M_StateData?.filter(obj => obj?.key === 'firstRows')[0]?.value
                const tempCnies = M_StateData?.filter(obj => obj?.key === 'companies')[0]?.value
                const tempER = M_StateData?.filter(obj => obj?.key === 'expandedRows')[0]?.value

                if ((tempC !== "undefined" && tempC && (tempC)?.length !== 0) && (tempSC || tempGFV || tempMP || tempAFS || tempFCM || tempVFCM || tempMT || tempSF || tempOI || tempO || tempIT || tempRE || tempVA || tempIC || tempEM || tempR || tempTR || tempV || tempSV || tempPS || tempP || tempFR || tempCnies || tempER)) {
                    setSelectedColumns((tempSC))
                    setGlobalFilterValue((tempGFV))
                    setMetaPair((tempMP))
                    setAdvFilterString((tempAFS))
                    setFilteredColumnModal((tempFCM))
                    setValueFilteredColumnModal((tempVFCM))
                    setColumns((tempC))
                    setMetaType((tempMT))
                    setShowFilters((tempSF))
                    setOrderInfo((tempOI))
                    setOperation((tempO))
                    setIsTable((tempIT))
                    setRowEdit((tempRE))
                    setValueAdd(new Map((tempVA)))
                    setIsCopy((tempIC))
                    setEditMap(new Map((tempEM)))
                    setRow((tempR))
                    setTotalRows((tempTR))
                    setViews(new Map((tempV)))
                    setSelectedView((tempSV))
                    setPageSize((tempPS))
                    setPage((tempP))
                    setFirstRows((tempFR))
                    setCompanies((tempCnies))
                    setExpandedRows((tempER))
                    setIsLoaded(false)
                    ctx.setIsLoad(false)
                    if (stopSaveRows) {
                        getWithFilters(tempOI, tempP, tempPS, tempMP)
                    }
                    return
                }
            }
        }
        options()
        setViews(new Map(views.set('Default', '?page=1&pagesize=20')))
        ctx.setIsLoad(false)
    }

    // eslint-disable-next-line
    useEffect(() => {
        if (refresh) {
            setRefresh(false)
            changeView(selectedView)
        }
    }, [refresh, selectedView, setRefresh])

    useEffect(() => {
        if (onHideLabels) onHideLabels(maxWidth)
    }, [maxWidth, onHideLabels])

    useEffect(() => {
        if (Array.isArray(value)) {
            if (value.length === 0) {
                setSelectedRows([])
            }
            return
        }

        if (!value) {
            setSelectedRows([])
        }
    }, [value])

    useEffect(() => {
        if (manualId === undefined) {
            const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
            if (newId !== id) {
                setId(newId)
                getSessionStorageData(newId)
            }
        } else {
            if (manualId !== id) {
                setId(manualId)
                getSessionStorageData(manualId)
            }
        }
    }, [manualId, M_State, id])

    useEffect(() => {
        if (isPage) {
            const tempArray = []
            sessionKeys.forEach((key) => {
                const tempSessionStorage = sessionStorageMachine(id, key, key)
                if (tempSessionStorage) {
                    tempArray.push(sessionStorageMachine(id, key, key))
                }
            })
            dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))

        }
        // eslint-disable-next-line
    }, [id, rows, columns, selectedColumns, globalFilterValue, metaPair, advFilterString, filteredColumnModal, valueFilteredColumnModal, selectedRows, metaType, showFilters, orderInfo, operation, isTable, rowEdit, valueAdd, isCopy, editMap, row, totalRows, views, selectedView, pageSize, page, firstRows, companies, expandedRows])

    useEffect(() => {
        return () => {
            if (globalSearchTimeoutRef.current) {
                clearTimeout(globalSearchTimeoutRef.current)
            }
        }
    }, [])

    const options = () => {
        setMetaType([])
        setColumns([])
        setSelectedColumns([])
        setFilteredColumnModal([])

        bufferServiceOptions.options(true).then(data => {
            if (data.name === 'AxiosError') {
                toastMessages('error', data.message, '')
                return
            }
            let tempArray = []
            let tempColumnArray = []
            let tempSelectedColumnsArray = []
            let tempFilteredColumnArray = []

            let tempCompanies = M_State.filter(obj => obj.key === 'companies')[0]?.value

            if (!tempCompanies || tempCompanies[0].AccountId === null || tempCompanies[0].AccountId === undefined) {
                tempCompanies = []
            }
            setCompanies(tempCompanies)

            data.forEach((element) => {
                setMetaType(prev => [...prev, {
                    'metaName': element.Name,
                    'metaType': element.Type,
                    'metaDisplay': element.NormalizedName,
                    'metaIsList': element.IsHiddenList,
                    'metaIsEdit': element.IsHiddenEdit,
                    'metaMinLen': element.MinLen,
                    'metaMaxLen': element.MaxLen,
                    'metaIsRequired': element.IsRequired,
                    'metaIsForeignKey': element.IsForeignKey,
                    'metaForeignKeyName': element.ForeignKeyName,
                    'metaForeignTableName': element.ForeignTableName,
                    'metaForeignTableToPassId': element.ForeignTableToPassId,
                    'metaGroupByInfo': element.GroupByInfo,
                    'metaEnumValues': element.EnumValues
                }])

                if (element.IsHiddenList) return

                tempArray.push({ ...element, name: element.Name })
                tempColumnArray.push({ ...element, name: element.Name })
                tempSelectedColumnsArray.push({ ...element, name: element.Name })
                tempFilteredColumnArray.push({ ...element, name: element.Name })
            })

            setFilteredColumnModal(tempFilteredColumnArray)
            setSelectedColumns(tempSelectedColumnsArray)
            setColumns(tempColumnArray)
            setAllColumns(tempArray)
            changeView(selectedView)
        })
    }

    const get = (passData) => {
        setRows([])
        if (!isLoaded) setLoading(true)
        const newUrl = filterService.queryBuilder(page, pageSize, undefined, undefined, FILTER, query)
        fetchRows(newUrl).then(data => {
            ctx.setIsLoad(false)
            setIsLoaded(false)
            setLoading(false)
            if (data.name === 'AxiosError') {
                toastMessages('error', data.message, '')
                setRows([])
                setTotalRows([])
                return
            }
            selectedIncomingValue(data)
            setTotalRows(data.TotalItems)
            setRows(data.Items)
            if (groupField) {
                setExpandedRows(data.Items)
            }
            if (value && valueField) {
                if (value[valueField]) {
                    setSelectedRows(data.Items.filter(obj => obj[valueField] === value[valueField]))
                }
            }
        })
    }

    // eslint-disable-next-line
    const deRetardationString = (data) => {
        return data.replace(/([A-Z])/g, ' $1').trim()
    }

    const getType = (input) => {
        if (input === 'true' || input === 'false') {
            return 'boolean'
        } else if (/^-?\d+$/.test(input)) {
            return 'int32'
        } else {
            return 'string'
        }
    }

    const getValue = (input) => {
        if (input === 'true') {
            return true
        } else if (input === 'false') {
            return false
        } else if (/^-?\d+$/.test(input)) {
            return parseInt(input)
        } else if (/^-?\d*\.\d+$/.test(input)) {
            return parseFloat(input)
        } else {
            return input
        }
    }

    const getPermissions = () => {
        roles.forEach((role) => {
            if (role.match(nameForRole)) {
                const tempPerm = role.split(nameForRole)[1]
                setPermissions(prev => [...prev, tempPerm])
            }
        })
    }

    const saveFilter = (newView) => {
        setLoading(true)
        let url = filterService.advancedSearch(metaPair, true)
        setAdvFilterString(url)
        if (orderInfo.columnName) {
            url = filterService.orderBy(orderInfo, url)
        }
        const tempPageString = filterService.pagination(page, pageSize, undefined, query)
        url = tempPageString.concat(url)

        const newUrl = filterService.queryBuilder(page, pageSize, orderInfo, metaPair, FILTER, query)

        fetchRows(newUrl).then(res => {
            if (res.name === 'AxiosError') {
                toastMessages('error', res.message, '')
                setRows([])
                setTotalRows([])
                setLoading(false)
                setIsLoaded(false)
                return
            }
            selectedIncomingValue(res)
            setTotalRows(res.TotalItems)
            setRows(res.Items)
            setLoading(false)
            setIsLoaded(false)
        })
        setViews(new Map(views.set(newView, url)))
        setSelectedView(newView)
    }

    const changeView = (viewName) => {
        if (!isLoaded) setLoading(true)
        setAdvFilterString('')
        setMetaPair([])
        setOrderInfo({ columnName: '', orderbool: false })
        setSelectedView(viewName)
        const url = views.get(viewName)
        let objectFilterArray = []
        let objectOrderBy = { columnName: '', orderbool: false }
        if (url === undefined) {
            get()
            return
        }
        url.split('&').forEach((elem) => {
            if (elem.includes("filter")) {
                setAdvFilterString('&' + elem)
                let stringFilter = elem.split('filter=')[1]
                stringFilter = stringFilter.split(' and ')
                stringFilter.forEach((el) => {
                    const tempArray = el.split(' ')
                    let tempObj
                    let tempOp = ''
                    if (tempArray[0] == '') tempArray.shift()

                    tempObj = metaType.filter(meta => meta.metaName === tempArray[0])
                    if (tempArray[1] === 'eq') {
                        if (tempArray[1] === 'eq' && tempArray[2].includes('$')) {
                            tempOp = 'Contains'
                        } else {
                            tempOp = 'Equals'
                        }
                    }
                    if (tempArray[1] === 'Greater') tempOp = 'Greater'
                    if (tempArray[1] === 'Lesser') tempOp = 'Lesser'
                    let objectFilter
                    if (tempObj.length) {
                        objectFilter = {
                            name: tempArray[0],
                            display: tempObj[0].metaDisplay,
                            type: tempObj[0].metaType,
                            operation: tempOp,
                            value: tempArray[2].replaceAll("'", '').replaceAll("$", '')
                        }
                    } else {
                        if (tempArray[0].includes('contains')) {
                            tempOp = 'Contains'
                            objectFilter = {
                                name: tempArray[0].split(',')[0].replace('contains(', ''),
                                display: deRetardationString(tempArray[0].split(',')[0].replace('contains(', '')),
                                type: 'string',
                                operation: tempOp,
                                value: decodeURIComponent(tempArray[0]).split(',')[1].replace(')', '').replaceAll("'", '')
                            }
                        } else {
                            objectFilter = {
                                name: tempArray[0],
                                display: deRetardationString(tempArray[0]),
                                type: getType(tempArray[2].replaceAll("'", '').replaceAll("$", '')),
                                operation: tempOp,
                                value: getValue(tempArray[2].replaceAll("'", '').replaceAll("$", ''))
                            }
                        }
                    }
                    objectFilterArray.push(objectFilter)
                })
            }
            if (elem.includes('order')) {
                let stringOrder = elem.split('orderby=')[1]
                stringOrder = stringOrder.split(' ')
                let tempBool = ''
                if (stringOrder[1] === 'asc') tempBool = false
                if (stringOrder[1] === 'desc') tempBool = true
                objectOrderBy = { columnName: stringOrder[0].toUpperCase(), orderbool: tempBool }
            }
        })
        setMetaPair(objectFilterArray)
        setOrderInfo(objectOrderBy)

        const newUrl = filterService.queryBuilder(page, pageSize, objectOrderBy, objectFilterArray, FILTER, query)

        fetchRows(newUrl).then(res => {
            ctx.setIsLoad(false)
            setLoading(false)
            setIsLoaded(false)

            if (res.name === 'AxiosError') {
                toastMessages('error', res.message, '')
                setRows([])
                setTotalRows([])
                return
            }

            selectedIncomingValue(res)

            setTotalRows(res.TotalItems)
            setRows(res.Items)
            if (groupField) {
                setExpandedRows(res.Items)
            }
            if (value && valueField) {
                if (value[valueField]) {
                    setSelectedRows(res.Items.filter(obj => obj[valueField] === value[valueField]))
                }
            }
        })
    }

    const deleteView = (name) => {
        views.delete(name)
        setViews(new Map(views))
        if (selectedView === name) {
            setSelectedView('')
        }
    }

    const createView = (e) => {
        get(allColumns)
        setMetaPair([])
        setSelectedView('')
        handleClickCloseViews()
        setAnchorAF(document.getElementById('advFilter'))
    }

    const getWithFilters = (ord, newPage, newRows, adv) => {
        setLoading(true)
        const customPage = newPage ? newPage : page
        const customPageSize = newRows ? newRows : pageSize
        const customOrder = ord ? ord : orderInfo
        const customAdv = adv ? adv : metaPair


        let url = filterService.queryBuilder(customPage, customPageSize, customOrder, customAdv, FILTER, query)

        fetchRows(url).then(res => {
            if (res.name === 'AxiosError') {
                toastMessages('error', res.message, '')
                setRows([])
                setTotalRows([])
                setLoading(false)
                setIsLoaded(false)
                return
            }
            selectedIncomingValue(res)
            setTotalRows(res.TotalItems)
            setRows(res.Items)
            setLoading(false)
            setIsLoaded(false)
            if (groupField) {
                setExpandedRows(res.Items)
            }
        })
    }

    const addMetaPair = (filter) => {
        let tempBol = false
        if (metaPair.length) {
            metaPair.forEach((element) => {
                //* checking if it exists
                if (element.name === filter.name) {
                    tempBol = true
                }
            })
            if (tempBol === true) {
                //* editing if it already exists
                setMetaPair(metaPair.map((elem) => elem.name === filter.name ? { ...elem, operation: filter.operation, value: filter.value } : elem))
            }
            else {
                //* creating new if it doesnt exist
                setMetaPair(prev => [...prev, filter])
            }
        }
        else {
            //* creating if array empty
            setMetaPair([filter])
        }
    }

    //*submit filters
    const submitFilters = (input, order) => {
        setLoading(true)
        const data = input ? input : metaPair
        const passOrder = order ? order : orderInfo

        let url = filterService.queryBuilder(page, pageSize, passOrder, data, FILTER, query)

        fetchRows(url).then(res => {
            if (res.name === 'AxiosError') {
                toastMessages('error', res.message, '')
                setRows([])
                setTotalRows([])
                setLoading(false)
                setIsLoaded(false)
                return
            }

            selectedIncomingValue(res)

            setTotalRows(res.TotalItems)
            setRows(res.Items)
            setLoading(false)
            setIsLoaded(false)
            if (groupField) {
                setExpandedRows(res.Items)
            }
        })
        return url
    }

    //*clear all advanced filters
    const deleteAllFilters = () => {
        setLoading(true)
        setAdvFilterString('')
        setMetaPair([])
        const newUrl = filterService.queryBuilder(page, pageSize, orderInfo, undefined, FILTER, query)

        fetchRows(newUrl).then(res => {
            if (res.name === 'AxiosError') {
                toastMessages('error', res.message, '')
                setRows([])
                setTotalRows([])
                setLoading(false)
                setIsLoaded(false)
                return
            }

            selectedIncomingValue(res)

            setTotalRows(res.TotalItems)
            setRows(res.Items)
            setLoading(false)
            setIsLoaded(false)
            if (groupField) {
                setExpandedRows(res.Items)
            }
        })

    }

    //*delete advanced filters individually
    const deleteFilter = (filterName) => {
        const tempMeta = metaPair.filter(elem => elem.name !== filterName)
        setMetaPair(tempMeta)
        submitFilters(tempMeta)
    }

    //*sort the columns
    const order = (column) => {
        if (!column) return
        setLoading(true)
            let newOrderInfo = {}
            if (orderInfo.columnName === column) {
                if (orderInfo.orderbool === false) {
                    const resetOrder = { columnName: '', orderbool: false }
                    setOrderInfo(resetOrder)
                    if (globalFilterValue !== '') {
                        globalSearch(globalFilterValue, resetOrder)
                    } else {
                        getWithFilters(resetOrder)  //* advFilterString ? metaPair.length ? submitFilters() : globalFilter() : get()
                    }
                    return
                }
                newOrderInfo = { columnName: column, orderbool: !orderInfo.orderbool }
            } else {
                newOrderInfo = { columnName: column, orderbool: true }
            }
            setOrderInfo(newOrderInfo)
            let url = filterService.orderBy(newOrderInfo, advFilterString)
            const tempPageString = filterService.pagination(page, pageSize, undefined, query)
            url = tempPageString.concat(url)
            if (globalFilterValue === '') {

                let newUrl = filterService.queryBuilder(page, pageSize, newOrderInfo, metaPair, FILTER, query)
                // setOrderString(url)
                fetchRows(newUrl).then(res => {
                    if (res.name === 'AxiosError') {
                        toastMessages('error', res.message, '')
                        setRows([])
                        setTotalRows([])
                        setLoading(false)
                        setIsLoaded(false)
                        return
                    }

                    selectedIncomingValue(res)

                    setTotalRows(res.TotalItems)
                    setRows(res.Items)
                    setLoading(false)
                    setIsLoaded(false)
                    if (groupField) {
                        setExpandedRows(res.Items)
                    }
                })
            } else {
                globalSearch(globalFilterValue, newOrderInfo)
            }
    }

    //*table refresh / was refresh of all filters and sort
    const clear = () => {
        getWithFilters()
        setSelectedRows([])
        toastMessages('success', '', t("RefreshTable"))
    }

    const getColumnObj = (header) => {
        const tempArray = columns.filter(obj => obj.Header === header)
        return tempArray[0]
    }

    //*show and hide table columns
    const onColumnToggle = (data, event) => {
        let tempArray = []
        if (selectedColumns.find((element) => element.Name === data.name)) {
            tempArray = selectedColumns.filter(el => el.Name !== data.name)
            setSelectedColumns(tempArray)
            return
        } else {
            setSelectedColumns(prev => [...prev, data])
            return
        }
    }
    const isColumnChecked = (data) => {
        if (selectedColumns.find((element) => element.name === data)) {
            return true
        } else {
            return false
        }
    }

    //* search on show/hide columns
    const filterColumnModal = (data) => {
        setValueFilteredColumnModal(data)
        const regex = new RegExp(data)
        const tempElem = columns.filter((elem) => regex.test(elem.NormalizedName))
        setFilteredColumnModal(tempElem)
    }

    //*open delete confirmation modal
    const handleOpenDelete = (line) => {
        if (Array.isArray(line) && line.length > 0) {
            //DELETE BY SELECTING LINES
            setDataContextMenu(null)
            setOpenConfirmDelete(true)
        } else if (line && typeof line === 'object' && Object.keys(line).length > 0) {
            //DELETE BY CONTEXT MENU
            setDataContextMenu(line)
            setOpenConfirmDelete(true)
        } else {
            toastMessages('error', '', t("SelectedLine"))
        }
    }

    //*close delete confirmation modal
    const handleCloseConfirmDelete = () => {
        setDataContextMenu(null)
        setOpenConfirmDelete(false)
    }

    //*open add row to table page
    const handleOpenDialogAdd = () => {
        setOperation('Create')
        setRow(null)
        setIsTable(false)
    }

    //*open copy row from table page
    const handleOpenCopy = (selected) => {


        const row = selected ? selected : null

        if (row) {
            setIsCopy(true)
            setRow(row)
            setOperation('Copy')
            setIsTable(false)
        }
        else {
            setIsTable(true)
            toastMessages('error', '', t("SelectedLine"))
        }
    }

    //*open edit row from table page
    const handleOpenEdit = (selected) => {
        const row = selected ? selected : null
        if (row) {
            setRow(row)
            setOperation('Edit')
            setIsTable(false)
        }
        else {
            setIsTable(true)
            toastMessages('error', '', t("SelectedLine"))
        }
    }

    //* open view row from table page
    const handleView = (selected) => {
        const row = selected ? selected : null
        if (row) {
            setRow(row)
            setOperation('View')
            setIsTable(false)
        }
        else {
            setIsTable(true)
            toastMessages('error', '', t("SelectedLine"))
        }
    }

    const onlyVisibleItems = (lineArray) => {
        const dict = new Map()
        const objectArray = []
        lineArray.forEach(element => {
            let tempBol = false
            Object.entries(element).forEach(keyValue => {
                tempBol = false
                selectedColumns.forEach(header => {
                    if (header.Name === keyValue[0]) tempBol = true
                })
                if (tempBol) dict.set(keyValue[0], keyValue[1])
            })
            objectArray.push(Object.fromEntries(dict))
        })
        return objectArray
    }

    const onlyVisibleItemsNoImages = (lineArray) => {
        const dict = new Map()
        const objectArray = []
        lineArray.forEach(element => {
            let tempBol = false
            Object.entries(element).forEach(keyValue => {
                tempBol = false
                selectedColumns.forEach(header => {
                    if (header.Type === "byte[]" && header.Name === keyValue[0]) {
                        dict.set(keyValue[0], '')
                        return
                    }
                    if (header.Name === keyValue[0]) tempBol = true
                })
                if (tempBol) dict.set(keyValue[0], keyValue[1])
            })
            objectArray.push(Object.fromEntries(dict))
        })
        return objectArray
    }

    const createWorksheet = (data) => {
        const tempRows = onlyVisibleItems(data)
        const tempRowsNoImg = onlyVisibleItemsNoImages(data)
        const workbook = new Excel.Workbook()
        const worksheet = workbook.addWorksheet(entity)
        const tempCol = selectedColumns.map(col => {
            const temp = {
                header: col.NormalizedName,
                key: col.Name
            }
            return temp
        })
        worksheet.columns = tempCol
        worksheet.addRows(tempRowsNoImg)
        tempRows.forEach((row, index) => {
            Object.entries(row).forEach(([key, value]) => {
                if (selectedColumns.some(header => header.Type === "byte[]" && header.Name === key)) {
                    const imageId = workbook.addImage({
                        base64: `data:image/jpeg;base64,${value}`, // Assuming the value is a base64-encoded image
                        extension: 'jpeg', // Change the extension according to your image format
                    })
                    worksheet.properties.defaultRowHeight = 40
                    worksheet.addImage(imageId, {
                        tl: { col: selectedColumns.findIndex(header => header.Name === key), row: index + 1 },
                        ext: { width: 50, height: 50 } // Adjust width and height as needed
                    })
                }
            })
        })
        workbook.xlsx.writeBuffer().then(data => {
            const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            const blob = new Blob([data], { type: fileType })
            saveAs(blob, `${entity}.xlsx`)
            handleCloseMenuPrint()
            toastMessages('success', '', t("ExportSuccess"))
        })
    }

    //* Export Excel
    const exportExcel = () => {
        console.log("Exporting Excel...", selectedRows)
        if (selectedRows.length === 0) {
            bufferExportService.get().then(res => {
                console.log("Export service response:", res)
                if (res.name === 'AxiosError') {
                    ctx.toastMessages("error", t("DataLoadError"), '')
                    return
                }
                else {
                    createWorksheet(res?.Items ?? res)
                }
            })
        } else {
            createWorksheet(selectedRows)
        }
    }

    const exportTemplate = () => {
        const tempObj = new Object()
        metaType.forEach(obj => {
            if (obj.metaType === "byte[]" || obj.metaType === "guid") return
            if (obj.metaIsEdit === false) {
                tempObj[obj.metaDisplay] = ''
            }
        })
        const tempArray = [tempObj]
        var wb = XLSX.utils.book_new(),
            ws = XLSX.utils.json_to_sheet(tempArray)
        XLSX.utils.book_append_sheet(wb, ws, entity)
        XLSX.writeFile(wb, `${entity}_Template.xlsx`)
    }

    const importExcel = (e) => {
        ctx.setIsLoad(true)
        const file = e.target.files[0]
        const formData = new FormData()
        formData.append("file", file)
        bufferImportService.post(formData).then(resObj => {
            ctx.setIsLoad(false)
            if (resObj.name === 'AxiosError') {
                ctx.toastMessages('error', resObj.response.data, '')
                return
            }
            ctx.toastMessages('success', '', resObj)
            getWithFilters()
        })
        handleCloseMenuPrint()
    }

    //* table row selection
    const onSelectionChange = (e) => {
        let tempValue = []
        if (isSelectSingle) {
            if (e.value) {
                tempValue = [e.value]
            } else {
                tempValue = []
            }
        } else {
            if (e.type === 'all') {
                if (e.value.length) {
                    selectedRows.forEach(obj => {
                        if (!e.value.find(rowObj => rowObj.Id === obj.Id)) {
                            tempValue.push(obj)
                        }
                    })
                    tempValue.push(...e.value)
                } else {
                    selectedRows.forEach(obj => {
                        if (!rows.find(rowObj => rowObj.Id === obj.Id)) {
                            tempValue.push(obj)
                        }
                    })
                }
            } else {
                tempValue = [...e.value]
            }
        }

        if (isParentTable) {
            setParentLine(tempValue)
            onPassLine(tempValue)
        }
        if (onPassLine) {
            onPassLine(tempValue)
        }
        setSelectedRows([...tempValue])
    }

    const postDelete = () => {
        let tempArray = []
        if (dataContextMenu) {
            //* DELETE BY CONTEXT MENU
            bufferService.delete(dataContextMenu.Id).then(data => {
                if (data.name === 'AxiosError') {
                    toastMessages('error', data.response.data.errors, t("LabelTryAgain"))
                } else {
                    setDataContextMenu(null)
                    toastMessages('success', '', t("RemoveLine"))
                    setOpenConfirmDelete(false)
                    getWithFilters()
                }
            })
        } else {
            //* DELETE BY SELECTING LINES
            if (selectedRows.length) {
                tempArray = selectedRows
            }
        }
        tempArray.forEach((elem) => {
            bufferService.delete(elem.Id).then(data => {
                if (data.name === 'AxiosError') {
                    toastMessages('error', data.response.data.errors, t("LabelTryAgain"))
                } else {
                    setSelectedRows(null)
                    toastMessages('success', '', t("RemoveLine"))
                    setOpenConfirmDelete(false)
                    getWithFilters()
                }
            })
        })
    }

    const onPage = (event) => {
        setFirstRows(event.first)
        setExpandedRows([])
        const newPage = event.page + 1
        setPage(newPage)
        setPageSize(event.rows)
        //* send to filter to create query and attach to string
        getWithFilters('', newPage, event.rows)
    }

    const rightClick = (e) => {
        const headerEl = e.target.closest('[data-column-header]')
        if (!headerEl) return
        const column = headerEl.getAttribute('data-column-header')
        if (!column) return
        setColumnContextmenuString(column)
        ccm.current.show(e)
    }

    //*open export menu
    const handleClickOpenMenuPrint = (event) => {
        setAnchorEl(event.currentTarget)
    }

    //*close export menu
    const handleCloseMenuPrint = () => {
        setAnchorEl(null)
    }

    //*open menu show hide
    const handleClickOpenMenuHideColumns = (event) => {
        setAnchorEls(event.currentTarget)
    }

    //*close menu show/hide
    const handleCloseMenuHideColumns = () => {
        setAnchorEls(null)
    }

    const handleClickOpenViews = (event) => {
        setAnchorV(event.currentTarget)
    }

    const handleClickCloseViews = () => {
        setAnchorV(null)
    }

    const handleOpenAdvancedFilterMenu = (event) => {
        setAnchorAF(event.currentTarget)
    }

    //*Toast Messages
    const toastMessages = (type, alert, string) => {
        ctx.toastMessages(type, alert, string)
    }

    const extraButtonFunction = (data, func, need) => {
        const tempNeed = need !== null ? need : true
        if (data === undefined && tempNeed) {
            toastMessages('error', '', t("SelectedLine"))
            return
        }
        if (value) {
            func(selectedRows)
        } else {
            func(data)
        }
    }

    const runGlobalSearch = (value, order) => {
        setLoading(true)
        const tempNewValue = value
        let tempString = ''
        let first = true
        const tempOrder = order ? order : orderInfo
        let tempFullQuery = ''
        setGlobalFilterValue(tempNewValue)

        if (tempNewValue !== '') {
            metaType.forEach(tempCol => {
                switch (tempCol.metaType) {
                    case 'string':
                        tempString = tempString.concat(first ? ` contains(${tempCol.metaName}, '${encodeURIComponent(tempNewValue)}')` : ` or contains(${tempCol.metaName}, '${encodeURIComponent(tempNewValue)}')`)
                        first = false
                        break
                    case 'int32':
                        if (Number(tempNewValue) || Number(tempNewValue) === 0) {
                            tempString = tempString.concat(first ? ` ${tempCol.metaName} eq ${encodeURIComponent(tempNewValue)}` : ` or ${tempCol.metaName} eq ${encodeURIComponent(tempNewValue)}`)
                            first = false
                        }
                        break
                }
            })
            tempFullQuery = FILTER ? filterService.queryBuilder(page, pageSize, tempOrder, metaPair, FILTER + ' and (' + tempString + ')', query) : filterService.queryBuilder(page, pageSize, tempOrder, metaPair, tempString, query)
        } else {
            tempFullQuery = filterService.queryBuilder(page, pageSize, tempOrder, metaPair, FILTER, query)
        }

        fetchRows(tempFullQuery).then(res => {
            setLoading(false)
            setIsLoaded(false)
            if (res.name === 'AxiosError') {
                toastMessages('error', res.message, '')
                setRows([])
                setTotalRows([])
                return
            }
            selectedIncomingValue(res)
            setTotalRows(res.TotalItems)
            setRows(res.Items)
            if (groupField) {
                setExpandedRows(res.Items)
            }
        })
        // getWithFilters(null, null, null, tempString)
    }

    const globalSearch = (value, order) => {
        if (globalSearchTimeoutRef.current) {
            clearTimeout(globalSearchTimeoutRef.current)
        }

        runGlobalSearch(value, order)
    }

    const debouncedGlobalSearch = (value, order) => {
        setGlobalFilterValue(value)

        if (globalSearchTimeoutRef.current) {
            clearTimeout(globalSearchTimeoutRef.current)
        }

        globalSearchTimeoutRef.current = setTimeout(() => {
            runGlobalSearch(value, order)
        }, 350)
    }

    //*header table
    const header = (
        <div className="display header">
            <div className="menuIcon">
                <M_Button
                    marginNone={maxWidth ? false : true}
                    tooltip={t("RefreshTable")}
                    label={maxWidth ? t("RefreshTable") : ""}
                    icon={<i className='pi pi-refresh'></i>}
                    onClick={() => clear()}
                />
                {isCrud ? (
                    <>
                        {!removeItem.includes('Print') ?
                            <M_Button
                                marginNone={maxWidth ? false : true}
                                tooltip={t("Print")}
                                label={maxWidth ? t("Print") : ""}
                                icon={<i className='pi pi-print'></i>}
                                onClick={handleClickOpenMenuPrint}
                            />
                            :
                            <></>
                        }
                        <Menu
                            anchorEl={anchorEl}
                            open={openMenuPrint}
                            onClose={handleCloseMenuPrint}
                            className="menuExcel"
                        >
                            {permissions.includes('Create') && includeImportExcel ?
                                <MenuItem className='menuItem'>
                                    <input
                                        className='importExcel'
                                        type="file"
                                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                        onChange={importExcel}
                                    />
                                    {t("ImportExcel")}
                                </MenuItem>
                                : ''}
                            {permissions.includes('Create') && includeTemplateExcel ?
                                <MenuItem className='menuItem' onClick={exportTemplate}>
                                    {t("Template")}
                                </MenuItem>
                                : ''}
                            <MenuItem className='menuItem' onClick={exportExcel}>
                                {t("ExportExcel")}
                            </MenuItem>
                        </Menu>
                        {permissions.includes('Create') && !removeItem.includes('Create') ?
                            <M_Button
                                marginNone={maxWidth ? false : true}
                                tooltip={t("Add")}
                                label={maxWidth ? t("Add") : ""}
                                icon={<AddCircleOutlineOutlined style={{ color: 'var(--color-green-light)' }} />}
                                onClick={replaceFunctions?.get('Create') ? replaceFunctions?.get('Create') : () => handleOpenDialogAdd()}
                            />
                            : ''
                        }
                        {permissions.includes('Edit') && !removeItem.includes('Edit') ?
                            <M_Button
                                marginNone={maxWidth ? false : true}
                                tooltip={t("Edit")}
                                label={maxWidth ? t("Edit") : ""}
                                icon={<i className='pi pi-pencil iconTable'></i>}
                                onClick={replaceFunctions?.get('Edit') ? () => { replaceFunctions?.get('Edit')(selectedRows[selectedRows.length - 1]) } : () => handleOpenEdit(selectedRows[selectedRows.length - 1])}
                            />
                            : ''
                        }
                        {permissions.includes('Delete') && !removeItem.includes('Delete') ?
                            <M_Button
                                marginNone={maxWidth ? false : true}
                                tooltip={t("Delete")}
                                label={maxWidth ? t("Delete") : ""}
                                icon={<i className='pi pi-trash iconTable'></i>}
                                onClick={replaceFunctions?.get('Delete') ? () => replaceFunctions?.get('Delete')(selectedRows) : () => handleOpenDelete(selectedRows)}
                            />
                            : ''
                        }
                        {permissions.includes('Create') && (!removeItem.includes('Create') && !removeItem.includes('Copy')) ?
                            <M_Button
                                marginNone={maxWidth ? false : true}
                                tooltip={t("Copy")}
                                label={maxWidth ? t("Copy") : ""}
                                icon={<i className='pi pi-copy iconTable'></i>}
                                onClick={replaceFunctions?.get('Copy') ? () => replaceFunctions?.get('Copy')(selectedRows[selectedRows.length - 1]) : () => handleOpenCopy(selectedRows[selectedRows.length - 1])}
                            />
                            : ''
                        }
                    </>
                ) : ''}

                {newButtons.map((btn, index) => {
                    const key = btn.key || `${btn.element}-${index}`

                    if (btn.element === 'default') {
                        return (
                            <React.Fragment key={key}>
                                <M_Button
                                    marginNone={maxWidth ? false : true}
                                    tooltip={btn.label}
                                    label={maxWidth ? btn.label : ""}
                                    icon={btn?.icon ? btn?.icon : <img style={btn.style} src={btn.source} alt={btn.label} className="iconTable" />}
                                    onClick={() => extraButtonFunction(selectedRows[selectedRows.length - 1], btn.command, btn?.needLine)}
                                />
                                {btn.extraEl !== null ?
                                    btn.extraEl
                                    : ''}
                            </React.Fragment>
                        )
                    }

                    if (btn.element === 'textfield' || btn.element === 'textField') {
                        return (
                            <div key={key} className="extraHeaderTextField">
                                <M_InputTextField
                                    label={btn.label}
                                    type={btn.type || 'text'}
                                    value={btn.value}
                                    onChange={btn.onChange}
                                    placeholder={btn.placeholder}
                                    size={btn.size}
                                    height={btn.height}
                                    minDate={btn.minDate}
                                    maxDate={btn.maxDate}
                                    disabled={btn.disabled}
                                    noAutoShrink={btn.noAutoShrink}
                                    inputHeight={btn.inputHeight}
                                    padding={btn.padding}
                                    margin={btn.margin}
                                />
                            </div>
                        )
                    }

                    return btn.element
                })}

                {inputText && inputText.length > 0 ? (
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px', marginRight: '10px' }}>
                        {inputText.map((inp, idx) => (
                            <div key={idx} className="inputField">
                                {inp.label && <label>{inp.label}</label>}
                                <input
                                    className='mInputTextFieldTable'
                                    type={inp.type || 'text'}
                                    value={inp.value}
                                    onChange={inp.onChange}
                                />
                            </div>
                        ))}
                    </div>
                ) : null}

            </div>
            {inputFilter && !filtersOnTable && <div className="menuSearch" style={{ right: '10px' }}>
                <M_InputTextField
                    iconEnd={<Search onClick={() => globalSearch(globalFilterValue)} style={{ color: ctx.primaryColor, cursor: 'pointer' }} />}
                    noAutoShrink
                    label={t('Search')}
                    value={globalFilterValue}
                    onChange={(event) => debouncedGlobalSearch(event.target.value)}
                    autoFocus
                    onEnter={() => globalSearch(globalFilterValue)}
                />
            </div>}
            {filtersOnTable ?
                <div className="menuSearch">
                    {inputFilter && <div style={{ marginRight: '10px' }}>
                        <M_InputTextField
                            iconEnd={<Search onClick={() => globalSearch(globalFilterValue)} style={{ color: ctx.primaryColor, cursor: 'pointer' }} />}
                            noAutoShrink
                            label={t('Search')}
                            value={globalFilterValue}
                            onChange={(event) => debouncedGlobalSearch(event.target.value)}
                            autoFocus
                            onEnter={() => globalSearch(globalFilterValue)}
                        />
                    </div>}
                    {selectedView}
                    <M_Button
                        marginNone={maxWidth ? false : true}
                        tooltip={t("Views")}
                        label={maxWidth ? t("Views") : ""}
                        icon={<PushPinOutlined style={{ transform: 'rotate(45deg)' }} />}
                        onClick={handleClickOpenViews}
                    />
                    <M_Button
                        marginNone={maxWidth ? false : true}
                        id={'advFilter'}
                        tooltip={t("Filters")}
                        label={maxWidth ? t("Filters") : ""}
                        icon={
                            <Badge anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                                badgeContent={metaPair.length}
                                sx={{
                                    "& .MuiBadge-badge": {
                                        color: "var(--color-white)",
                                        backgroundColor: `${color ? color : "var(--color-black)"}`
                                    }
                                }} >
                                <FilterAltOutlinedIcon sx={{ height: '30px' }} />
                            </Badge>
                        }
                        onClick={handleOpenAdvancedFilterMenu}
                    />
                    <M_Button
                        marginNone={maxWidth ? false : true}
                        tooltip={t("editColumns")}
                        label={maxWidth ? t("editColumns") : ""}
                        icon={<VisibilityOutlinedIcon sx={{ height: '30px' }} />}
                        onClick={handleClickOpenMenuHideColumns}
                    />
                    <Menu
                        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                        transformOrigin={{ vertical: "top", horizontal: "center" }}
                        anchorEl={anchorEls}
                        open={openMenuHideColumns}
                        onClose={handleCloseMenuHideColumns}
                        className="organizeMenuSearchTable"
                        MenuListProps={{ disablePadding: true }}
                    >
                        <div className='stickyTopTable'>
                            <MenuItem disableRipple={true} className="organizeMenuItem" >
                                <InputBase
                                    onChange={(e) => { filterColumnModal(e.target.value) }}
                                    placeholder={t("Search")}
                                    className='organizeInputBase'
                                    inputProps={{ 'aria-label': 'Search Columns' }}
                                    value={valueFilteredColumnModal}
                                    startAdornment={
                                        <InputAdornment position="start"> <Search /> </InputAdornment>
                                    }
                                />
                            </MenuItem>
                        </div>
                        {filteredColumnModal.map((col, index) => (
                            <div className='menuSwtchs menuItem' key={index}>
                                <MSwitchButton label={col.NormalizedName} color={color ? color : "var(--color-black)"} checked={isColumnChecked(col.name)} onClick={(event) => onColumnToggle(col, event)} labelColor={"var(--color-black)"} />
                            </div>
                        ))}
                    </Menu>
                    <Menu
                        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                        transformOrigin={{ vertical: "top", horizontal: "center" }}
                        anchorEl={anchorV}
                        open={openMenuViews}
                        onClose={handleClickCloseViews}
                        className="menuViews"
                        MenuListProps={{ disablePadding: true }}
                    >
                        <div className='stickyTop center' style={{ borderBottom: '1px solid var(--color-grey-light)', marginBottom: '5px' }}>
                            {/* <MenuItem disableRipple={true} className="cursorDefault viewsLabel" >
                                {t("Views")}
                            </MenuItem> */}
                            <div className='midleViews menuitem'>
                                <div className='viewsMasterDiv'>
                                    <div style={selectedView === 'Default' ?
                                        { border: `1px solid ${color ? color : "var(--color-black)"}`, backgroundColor: `${color ? color : "var(--color-black)"}` } :
                                        { border: '1px solid var(--color-grey-light)', backgroundColor: 'transparent' }}
                                        className={selectedView === 'Default' ? 'defaultViewdiv' : 'defaultUnselectedViewDiv'}
                                        onClick={() => { changeView('Default') }}
                                    >
                                        <span className={selectedView === 'Default' ? 'spanSelectedView' : 'unselectSpanView'}> {t("LabelDefaultView")}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {Object.keys(Object.fromEntries(views)).map((col, index) => (
                            <div className='midleViews menuitem' key={index}>
                                {col !== 'Default' ?
                                    <div className='viewsMasterDiv'>
                                        <div
                                            style={selectedView === col ?
                                                { border: `1px solid ${color ? color : "var(--color-black)"}`, backgroundColor: `${color ? color : "var(--color-black)"}` } :
                                                { border: '1px solid var(--color-grey-light)' }}
                                            className={selectedView === col ? 'selectedViewsDiv' : 'unselectViewSpan'}
                                            onClick={() => { changeView(col) }}
                                        >
                                            <span className={selectedView === col ? 'spanSelectedView' : 'unselectSpanView'}> {col} </span>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <M_Button hoverEffect none icon={<Close />} onClick={() => deleteView(col)} borderColor={selectedView === col ? `${color ? color : "var(--color-black)"}` : 'var(--color-grey-light)'} />
                                        </div>
                                    </div>
                                    : ''
                                }
                            </div>
                        ))}
                        <div className='stickyBot center'>
                            <M_Button
                                icon={<i className="pi pi-plus-circle" style={{ fontSize: '1rem', color: 'var(--color-white)' }}></i>}
                                hoverEffect
                                backgroundColor={'var(--color-green)'}
                                labelColor={'var(--color-white)'}
                                onClick={(e) => createView(e)}
                                label={`${t('CreateNewView')}`}
                                width={25}
                            />
                        </div>
                    </Menu>
                </div>
                : ""}

            {filtersOnTable ? <div>
                <AdvanceFilter
                    color={color ? color : "var(--color-black)"}
                    onDeleteFilter={deleteFilter}
                    onDeleteAllFilters={deleteAllFilters}
                    onSubmitFilters={submitFilters}
                    onAddMetaPair={addMetaPair}
                    metaPair={metaPair}
                    metaType={metaType}
                    showFilters={showFilters}
                    anchorAF={anchorAF}
                    setAnchorAF={setAnchorAF}
                    onSaveFilter={saveFilter}
                    selectedView={selectedView}
                    views={views}
                    onToasts={(type, alert, string) => toastMessages(type, alert, string)}
                    colorOptions={tableColorOptions}
                />
            </div> : ""}
        </div>
    )

    const getAudit = (line) => {
        if (!line) {
            ctx.toastMessages('error', '', t("SelectedLine"))
        }
        auditService.getId(line?.Id).then(resAudit => {
            if (Array.isArray(resAudit)) {
                setAuditData(resAudit)
                setOpenAudit(true)
            } else {
                ctx.toastMessages('error', '', t("noAudit"))
            }

        })
    }

    const closeAudit = () => {
        setOpenAudit(false)
        setAuditData([])
    }

    const verifiedBodyTemplate = (rowData, field) => {
        return (
            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                <M_CheckBox disabled checked={rowData[field]} noPadding />
            </div>
        )
    }

    const statusBodyTemplate = (rowData, field) => {
        const colorBody = rowData.StateColor || rowData.ServiceOrderStateColor || getSeverity(rowData[field], field)

        if (hideDefaultColor && colorBody === '#000000') {
            return <div
                style={{ display: 'flex', fontWeight: 'bolder', justifyContent: 'center', textAlign: 'center', alignItems: 'center', borderRadius: '6px', padding: '3px 10px', fontSize: '0.8rem', }}>
                {t(rowData[field])}
            </div>
        }
        return <div
            style={{ display: 'flex', fontWeight: 'bolder', color: 'white', justifyContent: 'center', textAlign: 'center', alignItems: 'center', borderRadius: '6px', padding: '3px 10px', fontSize: '0.8rem', backgroundColor: colorBody }}>
            {t(rowData[field])}
        </div>
    }

    const imageBodyTemplate = (rowData, field) => {
        return <div
            style={{ width: '50px', display: 'flex', fontWeight: 'bolder', color: 'white', justifyContent: 'center', textAlign: 'center', alignItems: 'center', borderRadius: '6px', padding: '2px 10px', fontSize: '0.8rem' }}>
            <img width={'25px'} src={rowData[field] ? `data:image/jpeg;base64,${rowData[field]}` : '/images/noImage.png'} alt={field} />
        </div>
    }

    const headerElement = (col, iconForm) => {
        if (col.Type !== 'boolean' && col.Type !== 'string' && col.Type !== 'int32' && col.Type !== 'datetime' && col.Type !== 'decimal') {
            if (!removeHeaders.includes(col.Header)) {
                return (
                    <div className='columnTable' data-column-header={col.Header} title={col.Header} style={{ display: 'flex', cursor: 'pointer' }}>
                        <div className='columnTable' title={col.Header} style={{ marginRight: '10px', color: 'var(--color-black)' }}>
                            {col.NormalizedName}
                        </div>
                        {infoElement && infoElement.get(col.Header) && <div className="tooltip"> ?
                            <span className="tooltiptext">
                                <ul style={{ listStyle: 'none' }}>
                                    {infoElement.get(col.Header).map((info, index) => (
                                        <li key={index} style={{ marginBottom: '10px' }}>
                                            {info}
                                        </li>
                                    ))}
                                </ul>
                            </span>
                        </div>}
                    </div>
                )
            }
        }

        if (!removeHeaders.includes(col.Header)) {
            return (
                <div onClick={() => order(col.Header)} className='columnTable' data-column-header={col.Header} title={col.Header} style={{ display: 'flex', cursor: 'pointer', alignItems: 'center' }}>
                    <div className='columnTable' title={col.Header} style={{ marginRight: '10px', color: 'var(--color-black)' }}>
                        {col.NormalizedName}
                    </div>
                    {iconForm === 'asc' ?
                        (<i className="pi pi-sort-amount-down "></i>) :
                        iconForm === 'desc' ?
                            (<i className="pi pi-sort-amount-up "></i>) :
                            iconForm === 'default' ?
                                (<i className="pi pi-sort-alt"></i>) :
                                (<i className="pi pi-sort-alt"></i>)
                    }
                    {infoElement && infoElement.get(col.Header) && <div className="tooltip">?
                        <span className="tooltiptext">
                            <ul style={{ listStyle: 'none', margin: '0', padding: '0' }}>
                                {infoElement.get(col.Header).map((info, index) => (
                                    <li key={index} style={{ marginBottom: '10px' }}>
                                        {info}
                                    </li>
                                ))}
                            </ul>
                        </span>
                    </div>}
                </div>
            )
        }
    }

    //*definition of table columns
    const dynamicColumns = selectedColumns.map((col, i) => {
        let iconForm = 'default'
        if (orderInfo.columnName === col.Header) {
            if (orderInfo.orderbool === false) {
                iconForm = 'asc'
            }
            if (orderInfo.orderbool === true) {
                iconForm = 'desc'
            }
        } else {
            iconForm = 'default'
        }
        if (col.Type === 'boolean') {
            return (
                <Column
                    id='head'
                    key={i}
                    dataType={col.Type}
                    field={col.Name}
                    header={headerElement(col, iconForm)}
                    body={(data) => verifiedBodyTemplate(data, col.Name)}
                    headerStyle={{
                        borderBottom: `2px solid ${color}`,
                        color: secondColor
                    }}
                ></Column>
            )
        }
        if (tableColorOptions.get(col.Name) || col.Name === 'Status' || col.Name === 'ServiceOrderState') {
            return (
                <Column
                    id='head'
                    key={i}
                    dataType={col.Type}
                    field={col.Name}

                    header={headerElement(col, iconForm)}
                    showAddButton={true}
                    body={(data) => statusBodyTemplate(data, col.Name)}
                    headerStyle={{
                        borderBottom: `2px solid ${color}`,
                        color: secondColor
                    }}
                ></Column>
            )
        }

        if (col.Type === 'byte[]') {
            return (
                <Column
                    id='head'
                    key={i}
                    dataType={col.Type}
                    field={col.Name}
                    header={headerElement(col, iconForm)}
                    showAddButton={true}
                    body={(data) => imageBodyTemplate(data, col.Name)}
                    headerStyle={{
                        borderBottom: `2px solid ${color}`,
                        color: secondColor
                    }}
                ></Column>
            )
        }

        return (
            <Column
                id='head'
                key={i}
                dataType={col.Type}
                field={col.Name}
                header={headerElement(col, iconForm)}
                showAddButton={true}
                headerStyle={{
                    borderBottom: `2px solid ${color}`,
                    color: secondColor
                }}
            ></Column>
        )
    })

    const buildHeaderGroup = () => {
        const hasGroupBy = selectedColumns.some(c => c.GroupByInfo)
        if (!hasGroupBy) return null

        return (
            <ColumnGroup>
                <Row>
                    <Column header="" colSpan={1} />
                    {(() => {
                        const result = []
                        let i = 0

                        while (i < selectedColumns.length) {
                            const current = selectedColumns[i]

                            if (!current.GroupByInfo) {
                                result.push(
                                    <Column key={i} header="" colSpan={1} />
                                )
                                i++
                                continue
                            }

                            const groupName = current.GroupByInfo
                            let span = 1

                            while (
                                i + span < selectedColumns.length &&
                                selectedColumns[i + span].GroupByInfo === groupName
                            ) {
                                span++
                            }
                            result.push(
                                <Column
                                    key={i}
                                    header={t(groupName)}
                                    colSpan={span}
                                    headerStyle={{
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                        borderBottom: `2px solid ${color}`,
                                        borderRight: `2px solid ${color}`,
                                        color: 'var(--color-black)',
                                        fontSize: '13px'
                                    }}
                                />
                            )

                            i += span
                        }

                        return result
                    })()}
                </Row>

                <Row>
                    <Column header="" />
                    {selectedColumns.map((col, i) => (
                        (() => {
                            const currentGroup = col.GroupByInfo
                            const nextGroup = selectedColumns[i + 1]?.GroupByInfo
                            const isGroupEnd = !!currentGroup && nextGroup && nextGroup !== currentGroup

                            return (
                        <Column
                            key={i}
                            header={headerElement(col, 'default')}
                            headerStyle={isGroupEnd ? { borderRight: `2px solid ${color}` } : {}}
                        />
                            )
                        })()
                    ))}
                </Row>
            </ColumnGroup>
        )
    }

    const rebuildContextMenu = () => {
        const tempArray = []
        if (!removeItem.includes('View')) {
            tempArray.push({ label: t("view"), icon: (<i className='pi pi-search' style={{ color: color, paddingRight: '5px' }}></i>), command: replaceFunctions?.get('View') ? () => { replaceFunctions?.get('View')(selectContext) } : () => handleView(selectContext) })
        }
        if (permissions.includes('Edit') && !removeItem.includes('Edit')) {
            tempArray.push({ label: t("Edit"), icon: 'pi pi-pencil', command: replaceFunctions?.get('Edit') ? () => { replaceFunctions?.get('Edit')(selectContext) } : () => handleOpenEdit() })
        }
        if (permissions.includes('Create') && !removeItem.includes('Create') && !removeItem.includes('Copy')) {
            tempArray.push({ label: t("Copy"), icon: 'pi pi-copy', command: replaceFunctions?.get('Copy') ? () => { replaceFunctions?.get('Copy')(selectContext) } : () => handleOpenCopy() })
        }
        if (permissions.includes('Delete') && !removeItem.includes('Delete')) {
            tempArray.push({ label: t("Delete"), icon: 'pi pi-trash', command: replaceFunctions?.get('Delete') ? () => { replaceFunctions?.get('Delete')(selectContext) } : (obj, data) => constextDeleteButton(obj, data) })
        }
        if (permissions.includes('Audit') && !removeItem.includes('Audit')) {
            tempArray.push({ label: t("Audit"), icon: 'pi pi-search', command: () => getAudit(selectContext) })
        }
        if (contextMenu.length) {
            contextMenu.forEach(objContext => {
                tempArray.push({
                    label: objContext.label,
                    icon: objContext.icon,
                    command: () => objContext.command(selectContext)
                })
            })
        }

        return tempArray
    }

    const constextDeleteButton = (event, data) => {
        const tempObj = { ...selectContext }
        setDataContextMenu(tempObj)
        handleOpenDelete(selectContext)
    }

    //loadingBar div styles
    const defaultStyle = { position: 'fixed', overflow: 'hidden', height: '100%', width: '-webkit-fill-available', zIndex: '5000000', backgroundColor: 'var(--color-grey-light)', opacity: '0.7' }
    const loadingStyle = { ...defaultStyle, height: '100vh' }
    const hideStyle = { ...defaultStyle, display: 'none' }
    const mainStyle = adjustingTableMedia2 ? { ...loadingStyle, top: '50px' } : { ...loadingStyle, top: '0px' }

    return (
        <>
            {isLoaded ? (<LoadingBar />) : (
                <div>
                    <ContextMenu model={columnContextMenu} onShow={e => cm.current.hide(e.originalEvent)} ref={ccm} />
                    {rebuildContextMenu().length !== 0 && <ContextMenu model={rebuildContextMenu()} onShow={e => ccm.current.hide(e.originalEvent)}
                        onHide={(e) => {
                            if (e && e.target.className !== 'p-menuitem-link') {
                                if (onPassContext) onPassContext(null)
                            }
                            setSelectContext(null)
                        }} ref={cm}
                    />}
                    {isTable ?
                        <div className='secondDivDataTable' onContextMenu={(e) => { rightClick(e) }} >
                            <DataTable
                                emptyMessage={t("LabelNoresultsFound")}
                                className='defaultTable'
                                tableStyle={{ width: '100%' }}
                                rowClassName={rowClassName}
                                header={header}
                                headerColumnGroup={buildHeaderGroup()}
                                value={rows}
                                size="small"
                                selection={!noSelect && selectedRows}
                                selectionMode={!noSelect && "multiple"}

                                stripedRows
                                responsiveLayout="scroll"
                                breakpoint="960px"
                                scrollHeight={height}
                                reorderableColumns

                                sortOrder={orderFields ? 1 : null}
                                sortField={orderFields ? groupField : null}
                                groupRowsBy={groupField}
                                rowGroupMode="subheader"
                                expandableRowGroups={rowGroup ? rowGroup : false}
                                expandedRows={expandedRows}
                                onRowToggle={(e) => {
                                    if (e.data && expandedRows) {
                                        let newValue = e?.data.filter(x => !expandedRows.includes(x))
                                        let oldValue = expandedRows.filter(x => !e?.data.includes(x))

                                        if (oldValue.length > newValue.length) {
                                            setExpandedRows(expandedRows.filter(prev => prev[groupField] !== oldValue[0][groupField]))
                                        }
                                        if (newValue.length > oldValue.length) {
                                            setExpandedRows(e.data)
                                        }
                                    } else {
                                        setExpandedRows(e.data)
                                    }
                                }}
                                rowGroupHeaderTemplate={headerTemplate}
                                rowGroupFooterTemplate={footerTemplate}

                                ref={dt} //necessário para o export de CSV
                                onSelectionChange={onSelectionChange}
                                contextMenuSelection={selectContext}
                                onContextMenuSelectionChange={e => {
                                    setSelectContext(e.value)
                                    if (onPassContext) onPassContext(e.value)
                                }}
                                onContextMenu={e => rebuildContextMenu().length !== 0 && cm.current.show(e.originalEvent)}
                            >
                                {isSelectSingle ?
                                    <Column
                                        headerStyle={{ borderBottom: `2px solid ${color}`, color: secondColor }}
                                        selectionMode="single" className='OpenTableCheckbox' frozen
                                    >
                                    </Column>
                                    :
                                    !noSelect && <Column
                                        headerStyle={{ borderBottom: `2px solid ${color}`, color: secondColor }}
                                        selectionMode="multiple" className='TableSelectionColumn' frozen
                                    >
                                    </Column>}
                                {dynamicColumns}
                            </DataTable>
                            {adjustingTableMedia3 ?
                                <Paginator
                                    className='paginator'
                                    rows={pageSize}
                                    totalRecords={totalRows} //* total pages
                                    first={firstRows} //* current page
                                    onPageChange={(e) => onPage(e)}
                                />
                                :
                                <Paginator
                                    className='paginator'
                                    rows={pageSize}
                                    totalRecords={totalRows} //* total pages
                                    first={firstRows} //* current page
                                    onPageChange={(e) => onPage(e)}
                                    template={{ layout: 'PrevPageLink CurrentPageReport NextPageLink' }}
                                />
                            }
                        </div>
                        :
                        <CrudTable
                            metaType={metaType}
                            entity={entity}
                            onGetWithFilters={getWithFilters}
                            onToastMessages={toastMessages}
                            operation={operation}
                            setIsTable={setIsTable}
                            rowEdit={rowEdit}
                            setRowEdit={setRowEdit}
                            valueAdd={valueAdd}
                            setValueAdd={setValueAdd}
                            isCopy={isCopy}
                            setIsCopy={setIsCopy}
                            editMap={editMap}
                            setEditMap={setEditMap}
                            row={row}
                            isChildTable={isChildTable}
                            parentLine={parentLine}
                            field={field}
                            companies={companies}
                            hasConfirmation={hasConfirmation}
                        />
                    }
                    <M_MessageBoard
                        warning
                        open={openConfirmDelete}
                        onClose={handleCloseConfirmDelete}
                        title={<b>{`${t("Delete")} ${t(entityName)}`}</b>}
                        body={
                            <span>
                                {t("TitleConfirmDelete")} ?
                            </span>
                        }
                        footer={
                            <span style={{ display: 'flex' }}>
                                <M_Button
                                    icon={<Clear style={{ color: 'var(--color-white)' }} />}
                                    label={t("ButtonCancel")}
                                    backgroundColor={'var(--color-red)'}
                                    labelColor={'var(--color-white)'}
                                    onClick={handleCloseConfirmDelete}
                                />
                                <M_Button
                                    icon={<Done style={{ color: 'var(--color-white)' }} />}
                                    label={t("Delete")}
                                    backgroundColor={'var(--color-green)'}
                                    labelColor={'var(--color-white)'}
                                    onClick={postDelete}
                                />
                            </span>
                        }
                    />

                    <M_MessageBoard
                        open={openAudit}
                        onClose={closeAudit}
                        minWidth={'80vw'}
                        maxWidth={!breakAuditWidth2 && '100vw'}
                        top={!breakAuditWidth && breakAuditWidth2 && '0'}
                        left={!breakAuditWidth && breakAuditWidth2 && '0'}
                        body={

                            <div style={{ height: '70vh', overflow: 'auto', width: '100%', }}>
                                <div style={{ width: '100%', height: '60vh', }}>
                                    <h1 style={{ display: 'flex', justifyContent: 'center' }}>{entityName} Audit</h1>
                                    {auditData?.sort((a, b) => Date.parse(a?.CreationDate) - Date.parse(b?.CreationDate))?.map((obj, index) => (
                                        <Accordion
                                            sx={{
                                                border: '1px solid var(--color-black)',
                                                borderRadius: '10px !important',
                                                marginBottom: '20px',
                                                scrollbarWidth: '0px'
                                            }}
                                            key={index}
                                        >
                                            <AccordionSummary
                                                expandIcon={<ArrowDownward />}
                                            >
                                                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <div style={{ display: 'grid', gridTemplateColumns: !breakAuditWidth ? 'auto' : '33% 33% 33%', alignItems: 'center', width: '100%', marginBottom: '10px' }}>
                                                        <div style={{ display: 'flex' }}>
                                                            <div style={{ fontSize: '12px', marginRight: '10px', alignItems: 'center' }}>
                                                                {t("Action")}:
                                                            </div>
                                                            <div style={{ color: obj.Action == 'Create' ? 'var(--color-green)' : obj.Action == 'Update' ? 'var(--color-yellow)' : 'var(--color-black)', fontWeight: 'bolder' }}>
                                                                {obj.Action}
                                                            </div>
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div style={{ fontSize: '12px', marginRight: '10px' }}>
                                                                {t("CreatedByEmail")}:
                                                            </div>
                                                            <div style={{
                                                                textOverflow: 'ellipsis',
                                                                overflow: 'hidden',
                                                                whiteSpace: 'wrap'
                                                            }}>
                                                                {obj.CreatedByEmail}
                                                            </div>
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div style={{ fontSize: '12px', marginRight: '10px' }}>
                                                                {t("On")}:
                                                            </div>
                                                            <div >
                                                                {obj.CreationDate.replace('T', ' ').split('.')[0]}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </AccordionSummary>
                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                <div style={{
                                                    width: '80%',
                                                    borderBottom: `2px solid var(--color-black)`,
                                                    marginBottom: '10px',
                                                }}></div>
                                            </div>
                                            {obj.AuditFields.map((objField, indexFields) => (
                                                <AccordionDetails
                                                    key={indexFields}
                                                    sx={{
                                                        backgroundColor: indexFields % 2 && 'var(--color-grey-light)',
                                                        borderBottomLeftRadius: indexFields + 1 === obj?.AuditFields?.length && '10px',
                                                        borderBottomRightRadius: indexFields + 1 === obj?.AuditFields?.length && '10px'
                                                    }}
                                                >
                                                    <div style={{ color: 'var(--color-black)', display: 'grid', gridTemplateColumns: !breakAuditWidth ? 'auto' : '33% 33% 33%' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div style={{ fontSize: '12px', marginRight: '10px' }}>
                                                                {t("Field")}:
                                                            </div>
                                                            <div style={{
                                                                userSelect: 'all',
                                                                fontWeight: 'bold',
                                                                textOverflow: 'ellipsis',
                                                                overflow: 'hidden',
                                                                whiteSpace: 'wrap'
                                                            }}>
                                                                {objField.Field}
                                                            </div>
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div style={{ fontSize: '12px', marginRight: '10px' }}>
                                                                {t("OldValue")}:
                                                            </div>
                                                            <div style={{
                                                                userSelect: 'all',
                                                                fontWeight: 'bold',
                                                                textOverflow: 'ellipsis',
                                                                overflow: 'hidden',
                                                                whiteSpace: 'wrap'
                                                            }}>
                                                                {objField.OldValue || 'null'}
                                                            </div>
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div style={{ fontSize: '12px', marginRight: '10px' }}>
                                                                {t("NewValue")}:
                                                            </div>
                                                            <div style={{
                                                                userSelect: 'all',
                                                                fontWeight: 'bold',
                                                                textOverflow: 'ellipsis',
                                                                overflow: 'hidden',
                                                                whiteSpace: 'wrap'
                                                            }}>
                                                                {objField.NewValue || 'null'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </AccordionDetails>
                                            ))}
                                        </Accordion>
                                    ))
                                    }
                                </div>
                                <div style={{ position: 'absolute', top: '20px', right: '20px' }}>
                                    <M_Button
                                        none
                                        icon={<CloseRounded style={{ color: 'var(--color-red)', scale: '1.5' }} color='var(--color-red)' />}
                                        onClick={closeAudit}
                                    />
                                </div>
                            </div >

                        }
                    />

                </div>
            )}
            <div style={loading ? mainStyle : hideStyle}>
                <LoadingBar />
            </div>
        </>
    )
}
